import React from "react";
import { useTranslation } from "react-i18next";

import './widgets.scss'
import WidgetsGIF from '../../../../assets/agileDashboards/gifs/gif1.gif'

function HyaiaWidgets() {

    const { t } = useTranslation()

    return (
        <div className="container-hyaia-widgets">
            <div className="img-hyaia-widgets">
                <img src={WidgetsGIF} alt="" />
            </div>
            <div className="texts-hyaia-widgets">
                <h1>{t("rapid_dashboard.widgets.title")}</h1>
                <p>{t("rapid_dashboard.widgets.section_text_1")}</p>
                <p>{t("rapid_dashboard.widgets.section_text_2")}</p>
                <p>{t("rapid_dashboard.widgets.section_text_3")}</p>
                <p>{t("rapid_dashboard.widgets.section_text_4")}</p>
            </div>
        </div>
    )
}

export default HyaiaWidgets